export default "__VITE_ASSET__Cb7nBeJ6__"